import {ButtonVariant} from "@/components/button/Button.types.ts";
import {IconButton} from "@/components/iconButton/IconButton.tsx";
import {IconButtonSizeType} from "@/components/iconButton/IconButton.types.ts";
import {useState} from "react";
import {IoContractOutline, IoExpandOutline} from "react-icons/io5";

export const ToggleFullscreenButton = ({
  className,
  size,
  variant = "secondary",
}: {
  className?: string;
  size?: IconButtonSizeType;
  variant?: ButtonVariant;
}) => {
  const [isFullscreen, setIsFullscreen] = useState<boolean>(false);

  return (
    <IconButton
      icon={isFullscreen ? IoContractOutline : IoExpandOutline}
      variant={variant}
      size={size}
      className={className}
      onClick={() => {
        document.onfullscreenchange = () => {
          document.body.classList.toggle("fullscreen", !!document.fullscreenElement);
        };

        if (document.fullscreenElement) {
          document.exitFullscreen().then(() => setIsFullscreen(false));
        } else {
          document.documentElement.requestFullscreen().then(() => setIsFullscreen(true));
        }
      }}
    />
  );
};
